export default __webpack_public_path__ + "static/przejrzyste-warunki-2e612c8f7c0fddbce6823ace23cd734e.png";